import { MakeCall } from './createMakeCall';

import { PostUserKYCResponse, UpdateKYCStatusPayload } from './types/Kyc';

const updateKycStatus =
  (makeCall: MakeCall) =>
  (userId: 'me' | number, kycUUID: string, data: UpdateKYCStatusPayload) =>
    makeCall<PostUserKYCResponse>(
      'PUT',
      `/api/v2/user/${userId}/kyc/${kycUUID}/status`,
      {
        data,
      },
    );
export { updateKycStatus };
